<template>
  <div class="carCenter">
    <!-- 内置组件循环componentLists调用 -->
    <div v-for="(item, index) in componentLists" :key="index">
      <component :is="item.componentKey" v-bind="item.params" style="height: 100%"> </component>
    </div>
    <!-- 底部的广告 -->
    <div class="bottomImg">
      <img src="../../../assets/images/mall/fun-to-drive.jpg" alt="" />
      <div class="ad-right">
        <div class="ad-title">
          <span>精彩无限</span>
          <a href="https://www.chery.cn/BrandShow/brand">了解更多</a>
        </div>
        <div class="ad-body">
          <p class="line"></p>
          <p class="text">
            充分享受生活，被最新的潮流所带动。独特、个人、运动、时尚，用汽车来表达个人的生活方式。他们需要一辆看起来动感又炫酷的车...
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GroupCar from '@/views/activity/components/group-car.vue'
import Crowdfunding from '@/views/activity/components/crowdfunding.vue'
import Auction from '@/views/activity/components/auction.vue'
import lowerAuction from '@/views/activity/components/lowerAuction.vue'
import FlashSale from '@/views/activity/components/flashSale.vue'
import CarListChildren from '@/views/activity/components/carListChildren.vue'
import NewRetailList from '@/views/activity/components/newRetailList.vue'
import CherryPick from '@/views/activity/components/cherryPick.vue'
import other from '@/views/activity/components/other.vue'
import depositUp from '@/components/business/activity/depositUp.vue'
import gift from '@/views/activity/components/gift.vue'
import collocation from '@/views/activity/components/collocation.vue'
export default {
  name: 'CarList',
  data() {
    return {
      componentLists: []
    }
  },
  props: {
    showItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  methods: {},
  created() {
    this.componentLists = this.showItems.map((item) => {
      if (item.code === 'gather') {
        item.params = {
          crowdfunding: item,
          title: item.title
        }
        item.componentKey = 'Crowdfunding'
      } else if (item.code === 'groupBuy') {
        item.params = {
          groupCarList: item,
          title: item.title
        }
        item.componentKey = 'GroupCar'
      } else if (item.code === 'maizeng' || item.code === 'hot' || item.code === 'luckDraw') {
        item.params = {
          carListChildren: item
        }
        item.componentKey = 'CarListChildren'
      } else if (item.code === 'flashSale') {
        item.params = {
          carListChildren: item
        }
        item.componentKey = 'FlashSale'
      } else if (item.code === 'retail') {
        item.params = {
          xlsList: item
        }
        item.componentKey = 'NewRetailList'
      } else if (item.code === 'choice') {
        item.params = {
          qrjxList: item
        }
        item.componentKey = 'CherryPick'
      } else if (item.code === 'auction') {
        item.params = {
          groupCarList: item,
          title: item.title
        }
        item.componentKey = 'auction'
      } else if (item.code === 'cutPrice') {
        item.params = {
          groupCarList: item,
          title: item.title
        }
        item.componentKey = 'lowerAuction'
      } else if (item.code === 'Deposit') {
        item.params = {
          data: item
        }
        item.componentKey = 'depositUp'
      } else if (item.code === 'gift') {
        // 买赠楼层
        item.params = {
          gitfData: item,
          title: item.title
        }
        item.componentKey = 'gift'
      } else if (item.code === 'collocation') {
        // 搭配购
        item.params = {
          gitfData: item,
          title: item.title
        }
        item.componentKey = 'collocation'
        // item.params = {
        //   qrjxList: item
        // }
        // item.componentKey = 'CherryPick'
      } else if (item.code === 'other') {
        item.params = {
          otherList: item
        }
        item.componentKey = 'other'
      }

      return item
    })
  },
  components: {
    FlashSale,
    CarListChildren,
    NewRetailList,
    CherryPick,
    Auction,
    lowerAuction,
    Crowdfunding,
    GroupCar,
    other,
    depositUp,
    gift,
    collocation
  }
}
</script>

<style lang="scss">
.carCenter {
  border-bottom: 1px solid #d8d8d8;
  width: 100%;
  background: rgba(245, 245, 245, 1);
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
}
.bottomImg {
  width: 1360px;
  min-width: 1200px;
  height: 120px;
  margin: 40px auto 0;
  background: url('../../../assets/images/mall/bottomBg.png') no-repeat;
  background-size: 100%;
  position: relative;
  img {
    display: inline-block;
    width: 124px;
    height: 80px;
    vertical-align: middle;
    margin: 0 5px 0 350px;
    position: relative;
    top: -30px;
  }
  .ad-right {
    display: inline-block;
    color: #fff;
    width: 520px;
    margin-top: 20px;
    .ad-title {
      span {
        font-weight: bold;
        font-size: 20px;
      }
      a {
        color: #c6001f;
        font-size: 12px;
        float: right;
      }
    }
    .ad-body {
      margin-left: 20px;
      .line {
        width: 80px;
        height: 2px;
        background: #c6001f;
        margin: 10px 0;
        transition: all 500ms linear 200ms;
      }
      .text {
        font-size: 12px;
        line-height: 15px;
      }
    }
    .ad-body:hover {
      .line {
        width: 150px;
        transition: all 500ms linear 200ms;
      }
    }
  }
}
</style>
